<template>
    <div v-if="!loading && project.id">
        <job-log v-if="project.dispersions.length != 0" subtitle="Dispersiones en progreso, actualiza en unos minutos."
            table-title="Dispersiones en progreso" :data="project.dispersions" ref="job_log"
            @refresh="update"></job-log>

        <div class="vx-row ">
            <div class="vx-col w-full lg:w-full">
                <vx-card class="mt-base" card-background="dark">
                    <h1 class="bold big-title m-0 text-white">{{ project.alias }},
                        PID :<a :href="$sanitizeUrl('/project/' + project.id)" class="text-secondary" target="_blank">{{
                            project.id }}</a>,
                        CID: <a :href="$sanitizeUrl('/user-record-creator')" class="text-secondary" target="_blank">{{
                            project.client_id }}</a>,
                        UID: <span>{{ project.userClientId }}</span>
                    </h1>
                </vx-card>
            </div>
        </div>

        <!-- DATOS BASICOS  DEL SOLICITANTE Y PROYECTO -->
        <div class="vx-row ">
            <div class="vx-col w-full lg:w-full xl:w-1/4">
                <vx-card class="mt-4">
                    <h5 class="ml-1 bold">Estado del activo: {{ explicitAssetStatus(project.asset_status) }}</h5>
                    <label class="ml-1 pill-danger" v-if="project.restructured_loan">Crédito Reestructurado</label>
                    <label class="ml-1 pill-dark">Credit status: {{ explicitCreditStatus(project.credit_status)
                        }}</label>
                    <label class="ml-1 pill-light bold">Agente cobranza: {{ project.collection_agent_name }}</label>
                    <vs-list>
                        <vs-list-item title="Tipo de persona">{{ translatePersonalType(project.client_user_person_type)
                            }}</vs-list-item>
                        <vs-list-item title="Producto">{{ project.financial_product }}</vs-list-item>
                        <vs-list-item title="Días de atraso"><span class="bold" :style="delayedDaysColor">{{
                                project.delayed }}</span></vs-list-item>
                        <vs-list-item title="Avance">{{ project.progress }}</vs-list-item>
                        <vs-list-item title="Ú. abono">${{ format_price(project.last_payment_amount, 2) }} ({{
                            compactDateFormat(project.last_payment_date) }})</vs-list-item>
                        <vs-list-item v-if="hasSupplier" title="Proveedor">{{ project.supplier.tradename
                            }}</vs-list-item>
                        <vs-list-item title="Clabe STP">
                            <template v-if="project.stpAccount != null" class="bold">{{ project.stpAccount }} <span
                                    :class="stpAccountColor(project.stpAccountStatus)"></span></template>
                            <template v-else class="bold">
                                <vs-button size="small" :disabled="!project.canCreateStpAccount" color="success"
                                    @click="confirmCreateStpAccount()">Crear</vs-button>
                            </template>
                        </vs-list-item>
                        <vs-list-item title="Clave de prevención">
                            <vs-select @input="switchProjectOption('cc_prevention_code')"
                                v-model="project.cc_prevention_code" placeholder="Seleccione una opción">
                                <vs-select-item :key="index" :value="item.value" :text="item.text"
                                    v-for="(item, index) in collections.ccPreventionCodeOptions" />
                            </vs-select>
                        </vs-list-item>
                        <vs-list-item title="Collection status">
                            <vs-select @input="switchProjectOption('collection_status')"
                                v-model="project.collection_status" placeholder="Seleccione una opción">
                                <vs-select-item :key="index" :value="item.value" :text="item.text"
                                    v-for="(item, index) in collectionStatusOptions" />
                            </vs-select>
                        </vs-list-item>
                        <vs-list-item title="Collection substatus">
                            <vs-select @input="switchProjectOption('collection_substatus')"
                                v-model="project.collection_substatus" placeholder="Seleccione una opción">
                                <vs-select-item :key="index" :value="item.value" :text="item.text"
                                    v-for="(item, index) in collectionSubStatusOptions" />
                            </vs-select>
                        </vs-list-item>
                        <!-- <vs-list-item title="Referencia Conekta">
                                  <template v-if="project.conektaAccount != null" class="bold">{{ project.conektaAccount }}</template>
                                  <template v-else class="bold">--</template>
                              </vs-list-item> -->

                        <!-- <vs-list-item title="Geolocalización"> 
                            <vs-button v-if="this.resultDataResponse.geolocation" target color="success" radius icon-pack="feather" icon="icon-map-pin" :href="$sanitizeUrl(this.resultDataResponse.geolocation)"></vs-button>
                            <label v-else>No disponible</label>
                        </vs-list-item> -->
                        <vs-list-item title="CSD">
                            <p class="bold" v-if="project.csd === null">No</p>
                            <vx-tooltip v-else-if="project.csd.status === 'error'"
                                :text="project.csd.status_description">
                                <span class="pill-danger bold">Sí, {{ project.csd.status | toStr }}</span>
                            </vx-tooltip>
                            <span :class="{
                                 'pill-warning': project.csd.status === 'pending_validation',
                                 'pill-success': project.csd.status === 'validated',
                              }" class="bold" v-else>Sí, {{ project.csd.status | toStr }}</span>
                        </vs-list-item>
                    </vs-list>
                </vx-card>
            </div>
            <div class="vx-col w-full lg:w-full xl:w-1/2">
                <vx-card class="mt-4">
                    <vs-tabs color="success" alignment="fixed" class="tab-action-btn-fill-container">
                        <vs-tab label="Contacto solicitante">
                            <div class="tab-text">
                                <div class="vx-row ">
                                    <div class="vx-col w-full lg:w-full">
                                        <vs-list>
                                            <vs-list-item :title="project.name" :subtitle="project.client_address">
                                                <template slot="avatar">
                                                    <vs-avatar color="primary" size="40px" />
                                                </template>
                                            </vs-list-item>
                                            <vs-list-item title="Email">
                                                <div v-if="hasRole('cobranza')"
                                                    class="flex justify-between flex-wrap small-flex">
                                                    <template v-if="!isUserEmailFormVisible">
                                                        <div class="flex">
                                                            <EmailableStatusComponent class="mt-3"
                                                                :source="project.emailable_verification_response">
                                                                <template slot="email">
                                                                    <label for="">{{ project.email }}</label>
                                                                </template>
                                                            </EmailableStatusComponent>
                                                            <vs-button class="ml-2" color="primary" type="flat"
                                                                icon-pack="feather" icon="icon-edit"
                                                                @click="isUserEmailFormVisible=true"></vs-button>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <div class="flex justify-between flex-wrap small-flex">
                                                            <vs-input size="small" type="text"
                                                                v-model.lazy="newEmailUser"
                                                                v-validate="'required|email'"
                                                                :danger="hasError('newEmailUser')"
                                                                :danger-text="errorText('newEmailUser')"
                                                                :success="isSuccess('newEmailUser')"
                                                                name="newEmailUser" />
                                                            <vs-button class="ml-2" size="small" color="success"
                                                                icon-pack="feather" icon="icon-check"
                                                                @click="confirmSaveNewUserEmail"></vs-button>
                                                            <vs-button class="ml-2" size="small" color="danger"
                                                                icon-pack="feather" icon="icon-x"
                                                                @click="isUserEmailFormVisible=false"></vs-button>
                                                        </div>
                                                    </template>
                                                </div>
                                                <span v-else>
                                                    <div class="flex">
                                                        <EmailableStatusComponent
                                                            :source="project.emailable_verification_response">
                                                            <template slot="email">
                                                                {{ project.email }}
                                                            </template>
                                                        </EmailableStatusComponent>
                                                    </div>
                                                </span>
                                            </vs-list-item>
                                            <vs-list-item v-if="project.email"
                                                title="Correos enviados"><user-emails-sent-list
                                                    :user-email="project.email"
                                                    email-stream="collection-stream" /></vs-list-item>
                                            <vs-list-item v-if="project.email"
                                                title="Contactos adicionales"><applicant-contacts
                                                    :client_id="project.client_id"
                                                    ref="applicantContacts"></applicant-contacts></vs-list-item>
                                            <vs-list-item v-if="project.aval" title="Obligado solidario">
                                                <vs-button size="small" color="success"
                                                    @click="popupAvalActive = true">Ver datos</vs-button>
                                            </vs-list-item>
                                            <!-- <vs-list-item v-if="project.owner" title="Dueño">
                                                <vs-button size="small" color="success" @click="popupOwnerActive = true">Ver datos</vs-button>
                                             </vs-list-item> -->
                                            <vs-list-item v-if="project.legal_rep" title="Representante legal">
                                                <vs-button size="small" color="success"
                                                    @click="popupLegalRepActive = true">Ver datos</vs-button>
                                            </vs-list-item>
                                            <vs-list-item title="Teléfono">
                                                <user-phone-status v-if="project && project.userClientId"
                                                    :user-id="project.userClientId" />
                                            </vs-list-item>
                                            <template v-if="project.work_data">
                                                <vs-list-header icon-pack="feather" icon="icon-briefcase"
                                                    title="Trabajo"></vs-list-header>
                                                <vs-list-item title="Domicilio"
                                                    :subtitle="project.work_data.full_address"></vs-list-item>
                                                <vs-list-item title="Teléfono"
                                                    :subtitle="project.work_data.phone"></vs-list-item>
                                            </template>
                                        </vs-list>
                                    </div>
                                </div>
                            </div>
                        </vs-tab>
                        <vs-tab label="Referencias">
                            <div class="tab-text">
                                <div class="vx-row ">
                                    <div class="vx-col w-full lg:w-full">
                                        <vs-table ref="referencesTable" stripe :data="project.relatedProfiles"
                                            noDataText="No se econtraron referencias de este solicitante">
                                            <template slot="thead">
                                                <vs-th>Nombre</vs-th>
                                                <vs-th>Teléfono</vs-th>
                                                <vs-th>Correo electrónico</vs-th>
                                                <vs-th>Tipo Relación</vs-th>
                                            </template>
                                            <template slot-scope="{ data }">
                                                <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                                                    <vs-td>{{ tr.name }}</vs-td>
                                                    <vs-td v-if="tr.phone">{{ tr.phone.phone }}</vs-td>
                                                    <vs-td v-else>--</vs-td>
                                                    <vs-td>
                                                        <EmailableStatusComponent
                                                            :source="tr.emailable_verification_response">
                                                            <template slot="email">
                                                                {{ tr.email }}
                                                            </template>
                                                        </EmailableStatusComponent>
                                                    </vs-td>
                                                    <vs-td>{{ projectReleatedProfilesRelationType[tr.relation_type] ||
                                                        "No definido" }}</vs-td>
                                                </vs-tr>
                                            </template>
                                        </vs-table>
                                    </div>
                                </div>
                            </div>
                        </vs-tab>
                        <vs-tab label="Garantías">
                            <div class="tab-text">
                                <div class="vx-row ">
                                    <div class="vx-col w-full lg:w-full">
                                        <vs-list>
                                            <vs-list-item v-if="project.locations.length === 0" title="Ubicación">
                                                <span class="bold">No registrada</span>
                                            </vs-list-item>
                                            <vs-list-item v-else-if="project.locations.length === 1" title="Ubicación">
                                                <span class="bold">{{ project.locations[0] }}</span>
                                            </vs-list-item>
                                            <vs-list-item v-else title="Ubicaciones">
                                                <vs-button color="success" size="small"
                                                    @click="popupLocationsActive = true">Ver</vs-button>
                                            </vs-list-item>
                                            <vs-list-item title="Es propietario del inmueble con paneles">
                                                <vs-button v-if="project.property_ownership.document1" color="success"
                                                    size="small"
                                                    @click="downloadFileRequest(project.property_ownership.document1.id)">Ver
                                                    Documento</vs-button>
                                                <span v-else class="bold">No</span>
                                            </vs-list-item>
                                            <vs-list-item title="Es propietario de otro inmueble">
                                                <vs-button v-if="project.property_ownership.document2" color="success"
                                                    size="small"
                                                    @click="downloadFileRequest(project.property_ownership.document2.id)">Ver
                                                    Documento</vs-button>
                                                <span v-else class="bold">No</span>
                                            </vs-list-item>
                                        </vs-list>
                                    </div>
                                </div>
                            </div>
                        </vs-tab>
                        <vs-tab label="Referencias BBVA">
                            <div class="tab-text">
                                <bbva-client-references :applicant-id="project.client_id"></bbva-client-references>
                            </div>
                        </vs-tab>
                    </vs-tabs>
                </vx-card>
            </div>
            <div class="vx-col w-full lg:w-full xl:w-1/4">
                <vx-card title="Preferencias y acciones" class="mt-4">
                    <h6 class="bold">Preferencias:</h6>
                    <ul class="centerx">
                        <li>
                            <vx-tooltip
                                text="Si activas esta opción, el solicitante y sus referencias no recibirán los recordatorios de pago.">
                                <vs-checkbox color="success" v-model="project.not_disturb"
                                    @change="switchClientOption('not_disturb')">No molestar</vs-checkbox>
                            </vx-tooltip>
                        </li>
                        <li>
                            <vx-tooltip :text="tooltipForInvoice">
                                <vs-checkbox class="mt-1" :disabled="!project.fiscal_validation_timestamp"
                                    color="success" v-model="project.invoice_required"
                                    @change="switchClientOption('invoice_required')">Requiere factura</vs-checkbox>
                            </vx-tooltip>
                        </li>
                        <li>
                            <vx-tooltip
                                text="Recuerda que dejar desactivada esta opción deja a los inversionistas sin sus pagos">
                                <vs-checkbox class="mt-1" color="success" @change="switchProjectOption('dispersion')"
                                    v-model="project.dispersion_enabled">Dispersión automática</vs-checkbox>
                            </vx-tooltip>
                        </li>
                        <li>
                            <vx-tooltip
                                text="Al activar esta opción el proyecto no se incluira en los reportes de círculo de crédito">
                                <vs-checkbox class="mt-1" color="success" @change="switchProjectOption('no_sic_report')"
                                    v-model="project.no_sic_report">Sin reporte SIC</vs-checkbox>
                            </vx-tooltip>
                        </li>
                        <li>
                            <vx-tooltip
                                text="Al activar esta opción los pagos del solicitante no serán procesados en la cobranza">
                                <vs-checkbox class="mt-1" color="success"
                                    @change="switchClientOption('payments_disabled')"
                                    v-model="project.payments_disabled">Deshabilitar Pagos</vs-checkbox>
                            </vx-tooltip>
                        </li>
                        <!-- <li>
                                <vs-checkbox class="mt-1" color="success" v-model="project.to_assign_debt_collector" @change="switchProjectOption('to_assign_debt_collector')">Gestión despacho cobranza</vs-checkbox>
                              </li> -->
                    </ul>
                    <div class="mt-5">
                        <h6 class="bold">Acciones:</h6>
                        <!-- <vs-button class="mr-1 mt-1" size="small" :disabled="!project.canCreateStpAccount" color="success" @click="confirmCreateStpAccount()">Crear cuenta STP</vs-button> -->
                        <div v-if="project.asset_status == liquidado" class="flex flex-wrap mt-1">
                            <vs-button size="small" color="dark" @click="confirmDownloadProjectSettlementLetter()">Carta
                                finiquito</vs-button>
                        </div>
                        <template v-else>
                            <div class="flex flex-wrap mt-1">
                                <!-- <project-recovery :project-id="project.id"
                                    :project-credit-status="project.credit_status"
                                    :default-supplier-id="project.supplier.id"
                                    :default-supplier-name="project.supplier.tradename"
                                    v-on:creditStatusUpdated="updateCreditStatus"></project-recovery> -->
                                <!-- <project-debt-reduction :project-id="project.id"
                                    :project-asset-status="project.asset_status"
                                    v-on:creditStatusUpdated="update"></project-debt-reduction> -->
                            <!-- </div>
                            <div class="flex flex-wrap mt-1"> -->
                                <vs-button size="small" color="dark" @click="downloadCertifiedProjectStatement()">Edo.
                                    cuenta certificado</vs-button>
                            </div>
                        </template>
                        <div class="flex flex-wrap mt-1">
                            <vs-button :disabled="!project.unique_slip" color="success" size="small"
                                @click="downloadUniqueSlip">Ver ficha</vs-button>
                            <vs-button class="ml-2" color="danger" size="small"
                                @click="confirmRecreateApplicantSlip">Recrear ficha</vs-button>
                        </div>
                        <div class="mt-5">
                            <h6 class="bold">Método de pago:</h6>
                            <vs-select class="w-full" @input="changeMethod" v-model="project.method"
                                placeholder="Seleccione una opción">
                                <vs-select-item :key="index" :value="item.value" :text="item.text"
                                    v-for="(item, index) in paymentMethodOptions" class="w-full" />
                            </vs-select>
                        </div>
                        <div class="mt-5">
                            <debt-collector-project-assignment :projectId="project_id" :currentDebtCollectorProjectAssignment="project.debt_collector_project_assignment" @updated="update"/>
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>


        <div v-if="project.hasProjectsWithStatus5" class="vx-row">
            <br>
            <div class="vx-col w-full">
                <vs-alert icon-pack="feather" icon="icon-info" color="warning">
                    <span>Este solicitante cuenta con un proyecto adicional <strong>en fondeo.</strong></span>
                </vs-alert>
            </div>
        </div>
        <!-- DATOS BASICOS  DEL SOLICITANTE Y PROYECTO -->

        <div class="vx-row mt-base">
            <div class="vx-col w-full">
                <vs-alert icon-pack="feather" icon="icon-info" color="warning" active="true">
                    <span>Es necesario mantener la bitácora de eventos actualizada.</span>
                </vs-alert>
            </div>
        </div>
        <vx-card>
            <vs-tabs v-model="activeTab" alignment="fixed" color="success" class="tab-action-btn-fill-container">
                <!-- NOTAS -->
                <vs-tab label="Notas internas">
                    <div class="tab-text">
                        <internal-notes :project-id="project.id" :client-id="project.client_id"
                            :display-popup="true"></internal-notes>
                    </div>
                </vs-tab>
                <!-- EVENTOS DE Gestión de Cobranza -->
                <!-- <vs-tab label="Gestión de Cobranza">
                    <div class="tab-text">
                        <administrative-cashing-project-events
                            :client-id="project.client_id"></administrative-cashing-project-events>
                    </div>
                </vs-tab> -->
                <!-- EVENTOS DE COBRANZA EXTRAJUDICIAL -->
                <!-- <vs-tab label="Cobranza extrajudicial">
                    <div class="tab-text">
                        <extrajudicial-cashing-project-events :client_id="project.client_id" v-on:cashingCreditStatusUpdated="updateCashingCreditStatus"></extrajudicial-cashing-project-events>
                    </div>
                </vs-tab> -->
                <!-- BITÁCORA DE EVENTOS -->
                <vs-tab label="Bitácora de Cobranza">
                    <div class="tab-text">
                        <cashing-project-event-log :client-id="project.client_id"></cashing-project-event-log>
                    </div>
                </vs-tab>
                <!-- REFERENCIAS DEL SOLICITANTE -->
                <!-- <vs-tab label="Referencias del solicitante">
                    <div class="tab-text">
                        <div class="vx-row">
                            <div class="vx-col w-full">
                                <vs-table
                                ref="referencesTable"
                                stripe
                                :data="project.relatedProfiles"
                                noDataText="No se econtraron referencias de este solicitante"
                                >
                                    <div slot="header">
                                        <h4>Referencias del solicitante</h4>
                                    </div>
                                    <template slot="thead">
                                        <vs-th>Nombre</vs-th>
                                        <vs-th>Teléfono</vs-th>
                                        <vs-th>Correo electrónico</vs-th>
                                        <vs-th>Tipo Relación</vs-th>
                                    </template>
                                    <template slot-scope="{ data }">
                                        <vs-tr
                                        :key="indextr"
                                        v-for="(tr, indextr) in data"
                                        :data="tr"
                                        >
                                        <vs-td>{{ tr.name }}</vs-td>
                                        <vs-td>{{ tr.phone }}</vs-td>
                                        <vs-td>{{ tr.email }}</vs-td>
                                        <vs-td>{{ projectReleatedProfilesRelationType[tr.relation_type] || "No definido" }}</vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>
                            </div>
                        </div>
                    </div>
                </vs-tab> -->
                <!-- NOTAS -->
                <vs-tab label="Negociaciones">
                    <div class="tab-text">
                        <negotiations-v2 :projectId="project.id" @updated="update"></negotiations-v2>
                    </div>
                </vs-tab>
            </vs-tabs>
        </vx-card>

        <!-- SECCION DE ABONOS Y PAGOS -->
        <div class="vx-row">
            <!-- <div class="col-xs-12 col-lg-12 col-xl-4">
                <vx-card class="mt-base">
                    <div class="flex justify-between">
                        <div class="flex flex-col">
                            <h4>Abonos vs Pagos</h4>
                        </div>
                        <div class="flex flex-col">
                            <feather-icon icon="ActivityIcon" class="inline-flex rounded-full text-white" :style="{background: `${project.integrityData.color1}`}"></feather-icon>
                        </div>
                    </div>
                    <div class="flex justify-between">
                        <div class="flex flex-col">
                            <span class="mb-1">Abonos</span>
                            <h4>{{ costFormat(project.integrityData.deposits) }}</h4>
                        </div>
                        <div class="flex flex-col">
                            <span class="mb-1">Pagos</span>
                            <h4>{{ costFormat(project.integrityData.payments) }}</h4>
                        </div>
                        <div class="flex flex-col">
                            <span class="mb-1">Diferencia</span>
                            <h4>{{ costFormat(project.integrityData.result1) }}</h4>
                        </div>
                    </div>
                </vx-card>
            </div> -->
            <!-- <div class="col-xs-12 col-lg-12 col-xl-6">
                <vx-card class="mt-base">
                    <div class="flex justify-between">
                        <div class="flex flex-col">
                            <h4>Pagos vs Dispersiones</h4>
                        </div>
                        <div class="flex flex-col">
                            <feather-icon icon="ActivityIcon" class="inline-flex rounded-full text-white" :style="{background: `${project.integrityData.color2}`}"></feather-icon>
                        </div>
                    </div>
                    <div class="flex justify-between">
                        <div class="flex flex-col">
                            <span class="mb-1">Pagos</span>
                            <h4>{{ costFormat(project.integrityData.payments) }}</h4>
                        </div>
                        <div class="flex flex-col">
                            <span class="mb-1">Dispersiones</span>
                            <h4>{{ costFormat(project.integrityData.dispertions) }}</h4>
                        </div>
                        <div class="flex flex-col">
                            <span class="mb-1">Diferencia</span>
                            <h4>{{ costFormat(project.integrityData.result2) }}</h4>
                        </div>
                    </div>
                </vx-card>
            </div>
            <div class="col-xs-12 col-lg-12 col-xl-6">
                <vx-card class="mt-base">
                    <div class="flex justify-between">
                        <div class="flex flex-col">
                            <h4>Pagos vs Amortización</h4>
                        </div>
                    </div>
                    <div class="flex justify-between">
                        <div class="flex flex-col">
                            <span class="mb-1">Pagos</span>
                            <h4>{{ costFormat(project.integrityData.paymentsAmortization) }}</h4>
                        </div>
                        <div class="flex flex-col">
                            <span class="mb-1">Amortización</span>
                            <h4>{{ costFormat(project.integrityData.amortization) }}</h4>
                        </div>
                        <div class="flex flex-col">
                            <span class="mb-1">Diferencia</span>
                            <h4>{{ costFormat(project.integrityData.result3) }}</h4>
                        </div>
                    </div>
                </vx-card>
            </div> -->
        </div>
        <!-- SECCION DE ABONOS Y PAGOS -->

        <!-- VENTANAS FLOTANTES Y MODALES -->
        <vs-popup title="Ubicaciones" :active.sync="popupLocationsActive">
            <vs-list v-for="(location,index) in project.locations" v-bind:key="index">
                <vs-list-item :title="location"></vs-list-item>
            </vs-list>
        </vs-popup>
        <vs-popup v-if="hasSupplier" title="Proveedor" :active.sync="popupSupplierActive">
            <vs-row>
                <vs-col vs-offset="2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
                    <img v-if="supplierLogoUrl !== null" width="50px" :src="supplierLogoUrl" alt="Logo">
                    <img v-else alt="" width="50px" src="https://cdn.redgirasol.com/green/perfiles/hombre-gorra.jpg" />
                </vs-col>
            </vs-row>
            <vs-list>
                <vs-list-item title="Nombre" :subtitle="project.supplier.tradename"></vs-list-item>
                <vs-list-item title="Correo" :subtitle="project.supplier.email"></vs-list-item>
                <vs-list-item title="Correo comercial" :subtitle="project.supplier.email2"></vs-list-item>
                <vs-list-item title="Teléfono" :subtitle="project.supplier.phone"></vs-list-item>
            </vs-list>
            <vs-list v-if="project.agent != null">
                <vs-list-header color="info" icon-pack="feather" icon="icon-user" title="Vendedor"></vs-list-header>
                <vs-list-item title="Nombre" :subtitle="project.agent.name"></vs-list-item>
                <vs-list-item title="Correo" :subtitle="project.agent.email"></vs-list-item>
                <vs-list-item title="Teléfono" :subtitle="project.agent.phone"></vs-list-item>
            </vs-list>
        </vs-popup>
        <vs-popup title="Obligado solidario" :active.sync="popupAvalActive">
            <div v-if="project.aval">
                <div class="con-userx flex items-center">
                    <vs-avatar color="warning" size="45px" :text="project.aval.first_name" />
                    <span>{{project.aval.fullname}}</span>
                </div>
                <vs-list>
                    <vs-list-header color="info" icon-pack="feather" icon="icon-user"
                        title="Información general"></vs-list-header>
                    <vs-list-item :subtitle="'Teléfono: '+project.aval.phone"></vs-list-item>
                    <vs-list-item :subtitle="'Email: '+project.aval.email"></vs-list-item>
                    <template v-if="project.aval.person_type==='pf'">
                        <vs-list-item :subtitle="'CURP: '+project.aval.curp"></vs-list-item>
                        <vs-list-item
                            :subtitle="'Fecha de nacimiento: '+this.midDateFormat(project.aval.birth_date)"></vs-list-item>
                    </template>
                    <vs-list-item v-else :subtitle="'RFC: '+project.aval.rfc"></vs-list-item>
                    <vs-list-header color="info" icon-pack="feather" icon="icon-home"
                        title="Dirección"></vs-list-header>
                    <vs-list-item :subtitle="project.aval.fulladdress"></vs-list-item>
                </vs-list>
            </div>
        </vs-popup>
        <!-- <vs-popup title="Dueño" :active.sync="popupOwnerActive">
            <div v-if="project.owner">
                <div class="con-userx flex items-center">
                    <vs-avatar color="warning" size="45px" :text="project.owner.first_name" />
                    <span>{{project.owner.fullname}}</span>
                </div>
                <vs-list>
                    <template>
                        <vs-list-item title="Nombres">{{ business_personal.first_name }} {{ business_personal.second_name }}</vs-list-item>
                        <vs-list-item title="Apellido paterno">{{ business_personal.last_name_1 }}</vs-list-item>
                        <vs-list-item title="Apellido materno">{{ business_personal.last_name_2||"--" }}</vs-list-item>
                        <vs-list-item title="Género">{{ translateGender(business_personal) }}</vs-list-item>
                        <vs-list-item title="CURP">{{ business_personal.curp||"--" }}</vs-list-item>
                        <vs-list-item title="RFC">{{ business_personal.rfc||"--" }}</vs-list-item>
                        <vs-list-item title="Fecha de nacimiento">{{ business_personal.birth_date||"--" }}</vs-list-item>
                        <vs-list-item title="Estado de nacimiento">{{ business_personal.birth_state_named||"--" }}</vs-list-item>
                        <vs-list-item title="País de nacimiento">{{ business_personal.origin_country_named||"--" }}</vs-list-item>
                        <vs-list-item title="Nacionalidad">{{ business_personal.citizenship_named }}</vs-list-item>
                        <vs-list-item title="Tel.">{{ business_personal.country_calling_code||"" }} {{ phoneFormat(business_personal.new_phone||"") }}</vs-list-item>
                        <vs-list-item title="Verificación de identidad">
                            {{ business_personal.identity_verifications.length > 0 ? getStatusStr(business_personal.identity_verifications[0].identity_status) : "No realizada" }}
                        </vs-list-item>
                        <vs-list-item title="Dirección">
                            <div class="ml-20 text-align-right">
                                {{ business_personal_address ? business_personal_address.full_address : "--" }}
                            </div>
                        </vs-list-item>
                    </template>
                </vs-list>
            </div>
        </vs-popup> -->
        <vs-popup title="Representante legal" :active.sync="popupLegalRepActive">
            <template v-if="project.legal_rep">
                <div class="con-userx flex items-center">
                    <vs-avatar color="warning" size="45px" :text=" project.legal_rep.first_name" />
                    <span>{{ project.legal_rep.fullname }}</span>
                </div>
                <vs-list>
                    <vs-list-header color="info" icon-pack="feather" icon="icon-user"
                        title="Información general"></vs-list-header>
                    <vs-list-item :subtitle="'Género: ' + translateGender(project.legal_rep)"></vs-list-item>
                    <vs-list-item :subtitle="'CURP: '+project.legal_rep.curp || '--'"></vs-list-item>
                    <vs-list-item :subtitle="'RFC: '+project.legal_rep.rfc || '--'"></vs-list-item>
                    <vs-list-item :subtitle="'Fecha de nacimiento: '+this.midDateFormat(project.legal_rep.birth_date) || '--'"></vs-list-item>
                    <vs-list-item :subtitle="'Estado de nacimiento: '+project.legal_rep.birth_state_named || '--'"></vs-list-item>
                    <vs-list-item :subtitle="'País de nacimiento: '+project.legal_rep.origin_country_named || '--'"></vs-list-item>
                    <vs-list-item :subtitle="'Nacionalidad: '+project.legal_rep.citizenship_named"></vs-list-item>
                    <vs-list-item :subtitle="'Tel.: '+ phoneFormat(project.legal_rep.new_phone||'')"></vs-list-item>
                    <vs-list-header color="info" icon-pack="feather" icon="icon-home"
                        title="Dirección"></vs-list-header>
                    <vs-list-item :subtitle="project.legal_rep.full_address ? project.legal_rep.full_address : '--'"></vs-list-item>
                </vs-list>
            </template>
        </vs-popup>

        <!-- FECHA PARA CARTA FINIQUITO -->
        <vs-prompt title="Fecha de contratación" @accept="downloadProjectSettlementLetter" color="success"
            accept-text="Confirmar" cancel-text="Cancelar" :active.sync="settlementLetterActivePrompt">
            <div class="con-exemple-prompt">
                <span>Indica la fecha que aparecerá en la carta finiquito (dd-mm-yyyy):</span>
                <vs-input class="w-full" type="text" v-model.lazy="contractsDate" name="contractsDate"
                    v-validate="'required'" autocomplete="off" placeholder="dd-mm-yyyy" />
            </div>
        </vs-prompt>
        <!-- VENTANAS FLOTANTES Y MODALES -->
    </div>
</template>

<script>
    import formatHelper from "@mixins/formatHelper";
    import creditStatusesHelper from "@mixins/creditStatusesHelper";
    import projectStatusesHelper from "@mixins/projectStatusesHelper";
    import dateHelper from "@mixins/dateHelper";
    import UserPhoneStatus from "@projects/UserPhoneStatus";
    import UserEmailsSentList from "@components/profile_shared/UserEmailsSentList";
    // import ProjectRecovery from "./ProjectRecovery";
    import AdministrativeCashingProjectEvents from "./AdministrativeCashingProjectEvents";
    // import ExtrajudicialCashingProjectEvents from "./ExtrajudicialCashingProjectEvents";
    import CashingProjectEventLog from "./CashingProjectEventLog";
    import JobLog from "@components/JobLog";
    import { ProjectReleatedProfilesRelationTypeEnum } from "../../../../bl/enums/ProjectReleatedProfilesRelationTypeEnum";
    import {formatMoney} from "../../../../components/admin/filters";
    import * as moment from 'moment';
    import { mapMutations } from 'vuex';
    import AssetStatusEnum from "@/bl/enums/AssetStatusEnum";
    import Datepicker from "vuejs-datepicker";
    import { es } from "vuejs-datepicker/dist/locale";
    // import ProjectDebtReduction from "./ProjectDebtReduction";
    const applicantContacts = require('@components/projectsv2/ApplicantContacts').default
    import InternalNotes from "@views/admin/cobranza/components/InternalNotes";
    import BbvaClientReferences from "@components/cashing/BbvaClientReferences.vue";
    import NegotiationsV2 from "@views/admin/cobranza/components/NegotiationsV2";
    import DebtCollectorProjectAssignment from "@views/admin/cobranza/components/DebtCollectorProjectAssignment.vue";

    export default {
        name: "ProjectInfo",
        props: ['project_id'],
        mixins: [formatHelper,dateHelper, creditStatusesHelper,projectStatusesHelper],
        components:{
            AdministrativeCashingProjectEvents,
            // ExtrajudicialCashingProjectEvents,
            CashingProjectEventLog,
            'applicant-contacts': applicantContacts,
            JobLog,
            // ProjectRecovery,
            UserPhoneStatus,
            UserEmailsSentList,
            Datepicker,
            // ProjectDebtReduction,
            InternalNotes,
            BbvaClientReferences,
            NegotiationsV2,
            DebtCollectorProjectAssignment
        },
        filters: {
            number_format: formatMoney,
            human_date(date) {
                return moment(date).lang("es").format("D MMM H:m");
            },
          toStr(val) {
            if (val === 'pending_validation')
              return 'Pendiente de validación'
            if (val === 'validated')
              return 'Validado'
            if (val === 'error')
              return 'Error'
          },
        },
        data(){
            return {
                es: es,
                liquidado: AssetStatusEnum.PAGADO,
                // dueCreditStatuses: [7, 12],
                // showCashingOptions: false,
                activeTab:0,
                applicant: { csds: null },
                project:{
                    client_id:null,
                    supplier:{},
                    agent: null,
                    integrityData: {
                        color1: null,
                        color2: null,
                    },
                    canCreateStpAccount: false,
                    stpAccount: null,
                    conektaAccount:null,
                    userClientId: null,
                    hasProjectsWithStatus5:false,
                    relatedProfiles: [],
                    dispersions: [],
                    aval: null,
                    owner: null,
                    legal_rep: null,
                    property_ownership: {
                        title1:"",
                        title2:""
                    },
                    locations:[],
                    work_data: null
                },
                loading: false,
                correos: [],
                new_email: '',
                projectReleatedProfilesRelationType: [],
                popupAvalActive: false,
                popupOwnerActive: false,
                popupLegalRepActive: false,
                popupSupplierActive: false,
                popupLocationsActive: false,
                paymentMethodOptions: [
                    { text: "Manual", value: 1 },
                    { text: "Automático", value: 2 },
                    { text: "Domiciliación", value: 3 },
                    { text: "Cuenta concentradora", value: 4 }
                ],
                paymentMethodOptions: [
                    { text: "Manual", value: 1 },
                    { text: "Automático", value: 2 },
                    { text: "Domiciliación", value: 3 },
                    { text: "Cuenta concentradora", value: 4 }
                ],
                collectionStatusOptions: [
                    { text: "Preventivo", value: 'preventive' },
                    { text: "Extrajudicial", value: 'extrajudicial' },
                    { text: "Judicial", value: 'judicial' },
                    { text: "Cerrado", value: 'closed' }
                ],
                collectionSubStatusOptions: [
                    { text: "Regularización del crédito", value: 'credit_regularization' },
                    { text: "Liquidación del crédito", value: 'credit_settlement' },
                    { text: "Reestructura de crédito", value: 'credit_restructuring' },
                    { text: "Entrega voluntaria de las garantías", value: 'voluntary_surrender' },
                    { text: "Entrega forzosa de las garantías", value: 'compulsory_surrender' },
                    { text: "Ejecución de quita", value: 'debt_reduction' },
                    { text: "Convenio judicial puesta al corriente", value : 'judicial_agreement_bring_current'},
                    { text: "Convenio judicial reestructura", value: 'judicial_agreement_restructuring'},
                    { text: "Convenio judicial dación de pago", value: 'judicial_agreement_payment_in_kind'},
                    { text: "Convenio judicial liquidación" , value: 'judicial_agreement_settlement'},
                    { text: "Convenio judicial liquidación a plazos", value : 'judicial_agreement_installment_settlement'}
                ],
                collections: {
                    ccPreventionCodeOptions: []
                },
                prevPaymentMethod: null,
                isUserEmailFormVisible:false,
                newEmailUser:null,
                settlementLetterActivePrompt: false,
                contractsDate: null
            }
        },
        computed: {
            hasSupplier() {
                return this.project.supplier != null;
            },
            supplierLogoUrl()
            {
                if(this.hasSupplier && this.project !== null && this.project.supplier.logo_file !== null && this.project.supplier.logo_file !== ''){
                    return this.ApiDomain + this.project.supplier.logo_file;
                }
                return null;
            },
            projectSupplierInitial(){
                if (this.hasSupplier && this.project.supplier.tradename) {
                    return this.project.supplier.tradename.charAt(0);
                }
                else{
                    return "P";
                }
            },
            projectApplicantInitial(){
                if (this.project.name) {
                    return this.project.name.charAt(0);
                }
                else{
                    return "S";
                }
            },
            tooltipForInvoice(){
                if (this.project.fiscal_validation_timestamp) {
                    return "Al activar esta opción, se emitirá una factura en cada pago realizado.";
                }
                else{
                    return "Para activar esta opción, es necesario que el solicitante llene su perfíl fiscal.";
                }
            },
            delayedDaysColor(){
                let color = "";
                let delayedDays = this.project.delayed;
                if (delayedDays >= 90) {
                    color = "red";
                } else {
                    if (delayedDays >= 61) {
                        color = "#FF6347";
                    } else {
                        if (delayedDays >= 31) {
                            color = "#FFA500";
                        } else {
                            if (delayedDays >= 11) {
                                color = "#303f9f";
                            } else {
                                color = "black";
                            }
                        }
                    }                   
                }
                return {
                    "color": color
                };
            }
        },
        async mounted(){
            this.hideMenu();
            await this.getCollections();
            await this.getInformation();
            const PRPRT = new ProjectReleatedProfilesRelationTypeEnum();
            this.projectReleatedProfilesRelationType = PRPRT.toArray()
            const {data} = await axios.get(`/api/applicant/${this.project.client_id}`)
            this.applicant = data;
        },
        methods: {
            ...mapMutations('menu', ['hideMenu']),
            async getCollections(){
                try {
                    let collectionsObjects = ['ccPreventionCodes'];
                    let params = "with[]=" + collectionsObjects.join("&with[]=");
                    let res = await axios.get(`/api/v1/forms/getFormCollections?${params}`);
                    let colls = res.data;
                    colls.ccPreventionCodes.forEach((opt) => {
                        this.collections.ccPreventionCodeOptions.push({
                            value: opt.id,
                            text: opt.name,
                        }); //conversion a sintaxis de vx-select
                    });
                } catch (e) {
                    this.warn(e);
                    this.failed = true;
                }
            },
            async getInformation(){
                // this.showCashingOptions = false;
                this.loading = true;
                this.showLoading(true);
                await axios.get('/api/cobranza/proyectos/'+ this.project_id + '/info').then(response => {
                    this.project =  response.data;
                    this.newEmailUser = this.project.email;
                    // if (this.dueCreditStatuses.includes(this.project.credit_status)) {
                    //     this.activeTab = 1;
                    //     this.showCashingOptions = true;
                    // }
                    this.prevPaymentMethod=this.project.method;
                }).catch(error => {
                    this.errorNotif("Aviso", 'Ha ocurrido un error intente mas tarde.', 4000);
                });
                this.loading = false;
                this.showLoading(false);
            },
            async changeMethod(){
                if (this.prevPaymentMethod === this.project.method) {
                    return;
                }
                this.showLoading(true);
                var data = {
                    project: this.project_id,
                    method: this.project.method
                }
                await axios.post('/api/cobranza/method', data).then(response => {
                    this.dataResponse = response.data;
                    this.showLoading(false);
                    this.successNotif("Aviso", response.data, 4000);
                    this.prevPaymentMethod = this.project.method;
                }).catch(error => {
                    this.project.method = this.prevPaymentMethod;
                    this.showLoading(false);
                    this.errorNotif("Aviso", error.response.data, 4000);
                });
            },
            confirmCreateStpAccount(){
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Aviso`,
                    text: '¿Estas seguro de crear la cuenta CLABE STP para el solicitante?',
                    acceptText: "Confirmar",
                    cancelText: "Cancelar",
                    accept: this.createStpAccount
                })
            },
            createStpAccount(){
                this.showLoading(true);
                axios.post('/api/stp/v1/account/applicantId/'+this.project.client_id, {}).then(response => {
                    if (response.data != null) {
                        this.project.canCreateStpAccount = false;
                        this.project.stpAccount = response.data.stp_clabe;
                    }
                    this.showLoading(false);
                }).catch(error => {
                    this.showLoading(false);
                    this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                })
            },
            async updateCreditStatus(){
                await this.getInformation();
            },
            async updateCashingCreditStatus(){
                this.successNotif("Aviso", 'Evento guardado exitosamente', 4000);
                await this.getInformation();
            },
            update(){
                this.$emit('updated', 1)
            },
            async switchClientOption(option) {
                this.showLoading(true);
                var value = false;
                switch (option) {
                    case "invoice_required":
                        value = this.project.invoice_required;
                        break;
                    case "not_disturb":
                        value = this.project.not_disturb;
                        break;
                    case "payments_disabled":
                        value = this.project.payments_disabled;
                        break;
                    default:
                        break;
                }
                await axios.post('/api/cobranza/switchClientOption', {
                    client_id: this.project.client_id,
                    option: option,
                    value: value
                }).then(response => {
                    this.successNotif("Aviso", 'Preferencia actualizada exitosamente.', 4000);
                    this.showLoading(false);
                }).catch(error => {
                    this.showLoading(false);
                    this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                })
            },
            async switchProjectOption(option){
                this.showLoading(true);
                let value = null;
                switch (option) {
                    case "no_sic_report":
                        value = this.project.no_sic_report;
                        break;
                    case "cc_prevention_code":
                        value = this.project.cc_prevention_code;
                        break;
                    case "dispersion":
                        value = this.project.dispersion_enabled;
                        break;
                    case "collection_status":
                        value = this.project.collection_status;                        
                        break;
                    case "collection_substatus":
                        value = this.project.collection_substatus;
                        break;
                    case "to_assign_debt_collector":
                        value = this.project.to_assign_debt_collector;
                        break;
                    default:
                        break;
                }
                await axios.post('/api/cobranza/switchProjectOption', {
                    project: this.project_id,
                    option: option,
                    value: value
                }).then(response => {
                    this.successNotif("Aviso", 'Opción actualizada exitosamente.', 4000);
                    this.showLoading(false);
                }).catch(error => {
                    this.showLoading(false);
                    this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                })
            },
            downloadFileRequest(document_id){
                let url = this.ApiDomain + "/storagev3/documents/"+`download_document_file/${document_id}/project/${this.project.id}?access_token=${this.AccessToken}`
                try {
                    window.open(url, "_blank");
                }
                catch (error) {
                }
            },
            downloadCertifiedProjectStatement() {
                window.open(`${this.ApiDomain}/api/downloadCertifiedProjectStatement/${this.project_id}?access_token=${this.AccessToken}`, "_blank");
            },
            confirmDownloadProjectSettlementLetter(){
                if (!this.project.contracts_date) {
                    this.settlementLetterActivePrompt = true;
                } else {
                    this.contractsDate = this.project.contracts_date;
                    this.downloadProjectSettlementLetter();
                }
            },
            downloadProjectSettlementLetter() {
                window.open(`${this.ApiDomain}/api/downloadProjectSettlementLetter/${this.project_id}/${this.contractsDate}?access_token=${this.AccessToken}`, "_blank");
            },
            searchClientInfo(){
               this.$router.push({ name: 'Creador de expedientes', params: {searchOptionSelected: "CID", inputSearch: this.project.client_id } });
            },
            confirmSaveNewUserEmail(){
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.$vs.dialog({
                            type: 'confirm',
                            color: 'danger',
                            title: `Aviso`,
                            text: '¿Estas seguro de actualizar el correo del solicitante?',
                            acceptText: "Confirmar",
                            cancelText: "Cancelar",
                            accept: this.saveNewUserEmail
                        })
                    }
                });
            },
            async saveNewUserEmail(){
                this.showLoading(true);
                await axios.put(`/api/backoffice/user/${this.project.userClientId}/email`, {
                    email: this.newEmailUser
                }).then(response => {
                    this.successNotif("Aviso", 'Opción actualizada exitosamente.', 4000);
                    this.project.email = this.newEmailUser;
                    this.isUserEmailFormVisible = false;
                    this.showLoading(false);
                }).catch(error => {
                    this.showLoading(false);
                    if (typeof error.response.data.message !== 'undefined') {
                        this.errorNotif("Aviso", error.response.data.message, 4000);
                    } else {
                        this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                    }
                })
            },
            hasError(val) {
                return this.errors.has(val);
            },
            errorText(val) {
                return this.errors.first(val);
            },
            isSuccess(val) {
                let ff = this.fields[val];
                return ff?.required && ff?.valid;
            },
            confirmRecreateApplicantSlip(){
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Aviso`,
                    text: '¿Estás seguro de recrear la ficha única de pago para este solicitante? (Considera que el pdf generado tendrá los últimos cambios de las opciones de pago del solicitante)',
                    acceptText: "Confirmar",
                    cancelText: "Cancelar",
                    accept: this.recreateApplicantSlip
                })
            },
            recreateApplicantSlip(){
               this.showLoading(true);
               axios.post('/api/cobranza/abonar/ficha', {
                  client_id: this.project.client_id
               }).then(response => {
                  this.successNotif('Aviso', 'Ficha creada y enviada por email.');
                  this.project.unique_slip = response.data;
                  this.showLoading(false);
               }).catch(error => {
                  this.showLoading(false);
                  if(error.response.data.message != undefined){
                        this.errorNotif("Aviso", error.response.data.message, 4000);
                  }else{
                        this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                  }
               });
            },
            downloadUniqueSlip() {
                window.open(`${this.project.unique_slip.public_url}`, "_blank");
            },
        }
    }
</script>

<style scoped>
    /* mouse over link */
    a:hover {
        color: #46c93a !important;
    }
    a:visited {
        color: #b9fb03 !important;
    }

    .switch {
        position: relative;
        display: inline-block;
        width: 40px;
        height: 17px;
    }

    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 13px;
        width: 13px;
        left: 2px;
        bottom: 2px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: #2196F3;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #2196F3;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(23px);
        -ms-transform: translateX(23px);
        transform: translateX(23px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }
    .md-chip{
        padding: 0 10px 0 0;;
        height: 40px;
    }
    .vx-card .vx-card__header .vx-card__title h6 {
        font-weight: bold !important;
    }
</style>
